let view = null;

export default {
	namespace: 'template-awards',
	beforeEnter: async ({ current, next, trigger }) => {
		const { default: AwardsView } = await import(
			/* webpackChunkName: "awards-view" */ '../../templates/AwardsView'
		);
		view = new AwardsView(next.container);
		view.init();
	},
	afterLeave: ({ current, next, trigger }) => {
		view.destroy();
		view = null;
	},
};
